export default import.meta.ROLLDOWN_FILE_URL_fGPXALdxBki0u1HmT0DvuQ